import { PickupServicesEnum } from '@/components/common/pickup-services-new/types';

export type TPoint = {
  name: string,
  address: string,
  id: string | number,
  cityId: string,
  type: PointTypeEnum,
  metro: TPointMetroStation[] | null,
  geo: TPointGeo | null,
  services: PickupServicesEnum[],
  needPrepay: boolean,
  availableOn: string,
  deliveryDateTo: string,
  deliveryDateFrom: string,
  deliveryPrice: number | null,
  availability?: {
    totalAmount?: number | null,
    delayed?: boolean,
  } | null,
  isConvenience?: boolean | null,
  status?: string | null,
  workMode?: string | null,
};

export enum PointTypeEnum {
  STORE = 'store',
  PVZ = 'pvz',
  POSTAMAT = 'postamat',
  POST_OFFICE = 'post',
}

export type TPointMetroStation = {
  name: string,
  geo: TPointGeo,
  line: {
    name: string,
    color: string,
  } | null,
} | null;

export type TPointGeo = {
  latitude: number,
  longitude: number,
};
